import React from 'react';
import { ISponsorIcon, ISponsorIconProps } from './SponsorIcon';
import { twMerge } from 'tailwind-merge';

export const EdXIcon: ISponsorIcon = React.forwardRef<SVGSVGElement, ISponsorIconProps>((props, ref) => {
  return (
    <svg
      className={twMerge('p-3', props.className)}
      xmlns="http://www.w3.org/2000/svg"
      data-sponsor="edx"
      viewBox="0 0 80 41.7"
      fill="white"
      style={{ 'enableBackground': 'new 0 0 80 41.7' } as any}
    >
      <g>
        <g>
          <path
            d="M36.5,14.7c-0.4-0.4-0.8-0.7-1.3-0.9c-0.6-0.2-1.2-0.3-1.8-0.3c-0.9,0-1.7,0.2-2.4,0.6c-0.8,0.4-1.4,1-2,1.6
			c-0.6,0.7-1,1.6-1.3,2.5c-0.3,1-0.5,2.1-0.5,3.2c0,0.7,0.1,1.3,0.3,2c0.2,0.6,0.5,1.1,0.9,1.5c0.4,0.4,0.8,0.8,1.3,1
			c0.5,0.2,1.1,0.4,1.7,0.4l0,0c0.9,0,1.7-0.2,2.5-0.6c0.8-0.4,1.4-1,2-1.7c0.6-0.8,1-1.6,1.3-2.6c0.3-1,0.5-2.1,0.5-3.2
			c0-0.7-0.1-1.3-0.3-2C37.2,15.7,36.9,15.2,36.5,14.7z"
          ></path>
          <path
            d="M18.9,14.6c-0.3-0.4-0.8-0.7-1.2-0.9c-0.5-0.2-1.1-0.3-1.7-0.3c-0.6,0-1.3,0.1-1.8,0.3c-0.6,0.2-1.1,0.6-1.6,1
			c-0.5,0.4-0.9,1-1.2,1.5c-0.3,0.6-0.6,1.3-0.8,2h9.3v0c0-0.1,0-0.2,0-0.3c0-0.1,0-0.3,0-0.4c0-0.5-0.1-1.1-0.2-1.6
			C19.5,15.5,19.3,15,18.9,14.6z"
          ></path>
          <path
            d="M47.4,6.8L48.9,0h-42L0,32.9h35.1l-1.9,8.8h33.6l7.4-34.9H47.4z M22.8,18.5c0,0.2,0,0.5,0,0.7c0,0.2,0,0.5-0.1,0.7
			c0,0.2,0,0.4-0.1,0.6H10.2c0,0.1,0,0.3,0,0.4c0,0.1,0,0.3,0,0.4c0,0.8,0.1,1.5,0.4,2.2c0.2,0.6,0.6,1.1,1,1.5
			c0.4,0.4,0.9,0.7,1.4,0.8c0.5,0.2,1,0.3,1.5,0.3c0.9,0,1.9-0.2,2.7-0.6c0.7-0.4,1.2-0.9,1.6-1.6h2.9c-0.2,0.7-0.5,1.3-0.9,1.8
			c-0.4,0.6-1,1.1-1.6,1.5c-0.7,0.4-1.4,0.8-2.2,1c-0.9,0.2-1.8,0.4-2.7,0.4c-0.9,0-1.8-0.2-2.7-0.5c-0.8-0.3-1.6-0.8-2.2-1.4
			c-0.6-0.6-1.2-1.4-1.5-2.2c-0.4-1-0.6-2-0.5-3.1c0-1.5,0.2-2.9,0.7-4.3c0.4-1.2,1-2.3,1.8-3.3c0.8-0.9,1.7-1.6,2.8-2.1
			c1.1-0.5,2.4-0.8,3.6-0.8c0.9,0,1.7,0.2,2.5,0.5c0.8,0.3,1.5,0.8,2.1,1.3c0.6,0.6,1.1,1.4,1.4,2.2c0.4,0.9,0.5,1.9,0.5,3
			C22.8,18.1,22.8,18.3,22.8,18.5z M35.7,28.4l0.5-2.3h-0.3c-0.6,0.8-1.4,1.5-2.3,1.9c-0.9,0.5-2,0.7-3,0.7c-0.8,0-1.6-0.2-2.4-0.5
			c-0.7-0.3-1.4-0.8-2-1.4c-0.6-0.6-1-1.4-1.3-2.2c-0.3-0.9-0.5-1.9-0.5-2.9c0-1,0.1-2,0.3-2.9c0.2-0.9,0.5-1.8,0.9-2.6
			c0.4-0.8,0.8-1.5,1.4-2.2c0.5-0.6,1.1-1.2,1.8-1.6c0.6-0.5,1.4-0.8,2.1-1c0.8-0.2,1.6-0.4,2.4-0.4c0.6,0,1.2,0.1,1.8,0.3
			c0.5,0.2,1,0.4,1.5,0.7c0.4,0.3,0.8,0.7,1.2,1.1c0.3,0.4,0.6,0.9,0.7,1.4h0.3l2.1-9.9h2.8l-5.1,23.9H35.7z M63.2,37.2h-6.1l-4-8.8
			h-0.5l-7.4,8.8H39l11.6-13.7l-5.4-12.1h6.3l3.6,8.4h0.3l6.8-8.4h6.2L57.3,24.1L63.2,37.2z"
          ></path>
        </g>
        <path
          d="M78.2,9l0.5,0.9h-0.4L77.9,9H78.2z M77.1,10V8h1c0.1,0,0.2,0,0.3,0.1c0.1,0,0.2,0.1,0.2,0.2c0.1,0.1,0.1,0.2,0.1,0.3
		c0,0.1,0,0.2-0.1,0.4c-0.1,0.1-0.1,0.2-0.2,0.2c-0.1,0.1-0.2,0.1-0.3,0.1h-0.8V9h0.7c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.1-0.2,0.1-0.3
		c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.2-0.1-0.2-0.1h-0.5V10L77.1,10L77.1,10z M77.8,10.8c0.3,0,0.6-0.1,0.9-0.2
		c0.3-0.2,0.5-0.4,0.6-0.6c0.2-0.3,0.2-0.6,0.2-0.9c0-0.3-0.1-0.6-0.2-0.9c-0.2-0.3-0.4-0.5-0.6-0.6c-0.3-0.2-0.6-0.2-0.9-0.2
		c-0.3,0-0.6,0.1-0.9,0.2c-0.3,0.2-0.5,0.4-0.6,0.6C76.1,8.4,76,8.7,76,9c0,0.3,0.1,0.6,0.2,0.9c0.2,0.3,0.4,0.5,0.6,0.6
		C77.2,10.7,77.5,10.8,77.8,10.8 M77.8,11.2c-0.3,0-0.6-0.1-0.9-0.2c-0.3-0.1-0.5-0.3-0.7-0.5c-0.2-0.2-0.4-0.4-0.5-0.7
		c-0.1-0.3-0.2-0.6-0.2-0.9c0-0.3,0.1-0.6,0.2-0.9c0.1-0.3,0.3-0.5,0.5-0.7C76.5,7.2,76.7,7.1,77,7c0.3-0.1,0.6-0.2,0.9-0.2
		c0.3,0,0.6,0.1,0.9,0.2c0.3,0.1,0.5,0.3,0.7,0.5c0.2,0.2,0.4,0.4,0.5,0.7C79.9,8.4,80,8.7,80,9c0,0.3-0.1,0.6-0.2,0.9
		c-0.1,0.3-0.3,0.5-0.5,0.7c-0.2,0.2-0.4,0.4-0.7,0.5C78.4,11.1,78.1,11.2,77.8,11.2"
        ></path>
      </g>
    </svg>
  );
});
EdXIcon.displayName = 'EdXIcon';
